import { apiClient } from '@/app/api/client';

export interface TargetAudience {
    persona?: string;
    painPoints?: string[];
    goal?: string;
}

export interface BrandVoice {
    tone?: string;
    style?: string;
    traits?: string[];
}

export interface JourneyStage {
    name: string;
    description?: string;
}

export interface ContentStrategy {
    targetAudience?: TargetAudience;
    brandVoice?: BrandVoice;
    journeyStages?: JourneyStage[];
    contentPillars?: string[];
}

export interface TenantSettings {
    businessName?: string;
    logoUrl?: string;
    website?: string;
    contentStrategy?: ContentStrategy;
    [key: string]: any;
}

export const tenantSettingsApi = {
    async getSettings(): Promise<TenantSettings> {
        const response = await apiClient.get<TenantSettings>('/api/tenant/settings');
        return response.data;
    },

    async updateSettings(settings: TenantSettings): Promise<void> {
        await apiClient.put('/api/tenant/settings', settings);
    }
};
